<template>
	<div>
		<el-date-picker :value="date" v-bind="$props" @change="change"
			:picker-options="type=='datetimerange'?pickerOptions:null">
		</el-date-picker>
		<div class="full" @click="calendarModal"></div>
		<vxe-modal v-model="calendarShow" confirm-button-text="确认" show-footer height="800" width="800" destroy-on-close
			:loading="loading" @show="show" transfer>
			<template #title>
				<span>{{title}}</span>
			</template>
			<template #default>

				<el-calendar v-model="calendarDate">
					<template slot="dateCell" slot-scope="{date, data}">
						<div :style="{'color':getNumBydate(data.day)>=maxNum?'#F56C6C':'#000000'}">
							<div :class="data.isSelected ? 'is-selected' : ''">
								{{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}}
							</div>
							<div v-if="getNumBydate(data.day)!=0" style="margin-top: 10px;font-weight: bold;">
								{{schedulingText +':'+getNumBydate(data.day)}}
							</div>
						</div>
					</template>
				</el-calendar>
<!-- 				<div style="color: #F56C6C;margin-left: 20px;">
					<span v-if="maxNum>0">最大排期数量:{{maxNum}}</span>
					<span v-else>不可排期</span>
				</div> -->

			</template>
			<template #footer>
				<vxe-button @click="calendarShow = false">返回</vxe-button>
				<vxe-button status="primary" @click="submit">确认</vxe-button>				
			</template>
		</vxe-modal>
	</div>

</template>
<style scoped>
	.is-selected {
		color: #1989FA;
	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			type: {
				default: () => {
					return 'date'
				}
			},
			size: {
				default: () => {
					return 'mini'
				}
			},
			format: {
				default: () => {
					return null
				}
			},
			valueFormat: {
				default: () => {
					return 'timestamp'
				}
			},
			prefixIcon: {
				default: () => {
					return 'none'
				}
			},
			unlinkPanels: {
				default: () => {
					return true
				}
			},
			schedulingText: {
				default: () => {
					return '已排期'
				}
			},
			title: {
				default: () => {
					return '请选择'
				}
			},
			maxNum: {
				default: () => {
					return 0
				}
			},
			schedulingtype: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				date: this.value,
				calendarDate: null,
				calendarShow: false,
				loading: true,
				schedulingList: [],
				//dateColor: ['#FFFFFF', '#F56C6C', '#FF8B8B', '#FFB6C1', '#FFD700', '#FFC0CB']
			}
		},
		created() {


		},
		mounted() {

		},
		watch: {
			date(v) {
				this.change(v)
			},
			value(v) {
				this.date = v
			}
		},
		computed: {

		},
		methods: {
			list() {

			},
			show() {
				this.getSchedulingList().then((res) => {
					this.schedulingList = res
					if (this.value) {
						this.calendarDate = this.value
					} else {
						this.calendarDate = new Date()
					}
					this.loading = false
				}, () => {
					
					this.calendarShow = false
				})
			},
			getSchedulingList() {
				return new Promise((resolve,reject) => {
					this.$api.scheduling.list({
						type: this.schedulingtype
					}).then((res) => {
						resolve(res)
					},()=>{
						reject()			
					})

				})
			},
			calendarModal() {
				this.calendarShow = true
			},
			getNumBydate(date) {
				let obj = this.schedulingList.find((item) => {
					return item.date == date
				})
				if (obj) {
					return obj.num
				} else {
					return 0
				}
			},
			submit() {
				if (this.calendarDate) {
					this.submitCondition().then(() => {
						let field = this.formCreateInject.field
						this.formCreateInject.api.setValue(field, this.calendarDate)
						//this.date = this.calendarDate
						this.calendarShow = false
					}, () => {
						this.$message.error('档期已满')
					})
				} else {
					this.$message.error('请选择日期')
				}
			},
			submitCondition() {
				return new Promise((resolve) => {
					this.date = this.calendarDate	
					this.calendarShow = false
					resolve()
					// let date = window.systemMethods.timestampToDate(new Date(this.calendarDate).getTime(),
					// 	true)
					//let num = this.getNumBydate(date)
					//this.date = this.calendarDate
					// if (num <= this.maxNum - 1) {
					// 	this.date = this.calendarDate
					// 	this.calendarShow = false
					// 	resolve()
					// } else {
					// 	reject()
					// }
				})

			}
		}
	}
</script>
